import {Card, styled} from '@mui/material';

const StyledCard = styled(Card)`
	box-shadow: none;
	padding: 16px;
	border: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

const StyledUnOrderList = styled('ul')`
	list-style: disc;
	padding-left: 36px;
`;

export {StyledCard, StyledUnOrderList};
